import { graphql } from "../gql";
import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { SpeakingClassLevel } from "../gql/graphql.ts";

const CreateTopicMutation = graphql(`
  mutation createTopic(
    $nameIt: String!
    $level: SpeakingClassLevel!
    $pdfUrl: String!
    $userGroupIds: [String!]
  ) {
    createTopic(
      nameIt: $nameIt
      level: $level
      pdfUrl: $pdfUrl
      userGroupIds: $userGroupIds
    ) {
      id
      name
      level
      userGroupIds
      userGroups {
        id
        name
      }
    }
  }
`);
export function useCreateTopic() {
  const [createTopicMutation, { loading }] = useMutation(CreateTopicMutation);

  const createTopic = useCallback(
    async (variables: {
      nameIt: string;
      level: SpeakingClassLevel;
      pdfUrl: string;
      userGroupIds?: string[];
    }) => {
      await createTopicMutation({
        variables,
      });
    },
    [createTopicMutation],
  );

  return {
    loading,
    createTopic,
  };
}
